module.exports = __webpack_public_path__ + "media/images/flags/16/Honduras-d1ea0e73defc3890ee79ae5ca40c3358.png";